const withRouter= require('react-router-dom');
const storageHelper =  require("./storageHelper");
const config = require('../../config');

const commonHelpers = {
  getLoggedUser: () => {
    const userSession = storageHelper.getFromStorage('loggedUser');
    const loggedUser = (userSession && userSession.hasOwnProperty('user') && userSession.hasOwnProperty('authentication')) ? userSession : null;
    return loggedUser;
  },
  addLoggedUser: (userObj) => {
    storageHelper.addToStorage('loggedUser',userObj);
    return true;
  },
  getConfig: () => {
    return config;
  },
  removeLoggedUser: () => {
    storageHelper.removeFromStorage('loggedUser');
    return true;
  },
  doLogout: () => {
    storageHelper.removeFromStorage('loggedUser');
    window.location.replace("/login");
  },
  makeForbidden: () => {
    window.location.replace("/forbidden");
  },
  handleFormOnFocus: (value) => {
    for (var key in value.validations) {
      if (value.validations.hasOwnProperty(key)) {
        value.validations[key].valid = true;
      }
    }
    return value;
  },
  getStates: () => {
    let statesList = storageHelper.getFromStorage('statesList');

    if(statesList && statesList.length !== 0){
      return statesList;
    }

      return null;

  },
  addStates: (statesObj) => {
    storageHelper.addToStorage('statesList',statesObj);
    return true;
  }
}

module.exports = commonHelpers;



// WEBPACK FOOTER //
// ./src/libs/helpers/commonHelpers.js